<ion-content class="ion-padding">
  <div class="reminder-container">
    <ion-icon name="download-outline"></ion-icon>
    <h5>Nueva versión disponible</h5>
    <p class="subtitle">
      Hay una nueva versión de la aplicación disponible con mejoras y correcciones.
    </p>
    <ion-button expand="block" shape="round" color="primary" (click)="update()">
      Actualizar
    </ion-button>
    <ion-button expand="block" shape="round" fill="clear" color="medium" (click)="skip()">
      Ahora no
    </ion-button>
  </div>
</ion-content>
